/* eslint-disable react/require-default-props */
import React, { lazy, Suspense } from 'react';
import type { SxProps } from '@mui/material';
import { FinancialsConfigureState } from '../services/financials.service';
import { loadFederatedModule } from '../../../utils/loadFederatedModule';

/**
 * Props passed to renderChildren by FinancialsConfigureModal.
 * Must match OKR/FinancialsConfigureModal FinancialsRenderChildrenProps.
 */
export type FinancialsRenderChildrenProps = {
  onRefetch?: () => void;
  state?: unknown;
  [key: string]: unknown;
};

/* FinancialsConfigureModal */
export type FinancialsConfigureModalProps = {
  initialDataProviderIds?: number[];
  open: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  onDelete: () => void;
  sx?: SxProps;
  baseUrl?: string;
  objectId: number; // objective id or keyResult id
  objectType: number; // 1: objective, 2: keyResult
  entityId?: number; // financials entity id
  initialValues?: Partial<FinancialsConfigureState>;
  externalSourceId?: number; // external object id
  externalCostBudgetResources?: {
    budget?: number;
    resources?: number;
    runningCost?: number;
  };
  renderChildren?: (props: FinancialsRenderChildrenProps) => React.ReactNode;
  onTrackEvent?: (eventName: string, props: Record<string, unknown>) => void;
  trackingLocation?: string;
};

const FinancialsConfigureModalLazy = lazy(
  async () => loadFederatedModule<typeof import('OKR/FinancialsConfigureModal')>('OKR/FinancialsConfigureModal'),
);

export const FinancialsConfigureModal = ({ open, ...props }: FinancialsConfigureModalProps) => (
  <Suspense fallback={null}>
    {open && <FinancialsConfigureModalLazy {...props} open />}
  </Suspense>
);
